import { render, staticRenderFns } from "./Consulta.vue?vue&type=template&id=2ff3a13d&scoped=true"
import script from "./Consulta.vue?vue&type=script&lang=ts"
export * from "./Consulta.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff3a13d",
  null
  
)

export default component.exports